"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalNames = exports.PaymentPortalSessionErrorModal = exports.SubscriptionSuccessModal = exports.UserOriginalSubscriptionModal = exports.UserCancelSubscriptionModal = exports.ChooseWalletModal = void 0;
const confirmation_disconnect_wallet_1 = __importDefault(require("./confirmation-disconnect-wallet"));
exports.ChooseWalletModal = confirmation_disconnect_wallet_1.default;
const original_cancel_subscription_1 = __importDefault(require("./original-cancel-subscription"));
exports.UserOriginalSubscriptionModal = original_cancel_subscription_1.default;
const payment_portal_session_error_1 = __importDefault(require("./payment-portal-session-error"));
exports.PaymentPortalSessionErrorModal = payment_portal_session_error_1.default;
const subscription_success_1 = __importDefault(require("./subscription-success"));
exports.SubscriptionSuccessModal = subscription_success_1.default;
const user_cancel_subscription_1 = __importDefault(require("./user-cancel-subscription"));
exports.UserCancelSubscriptionModal = user_cancel_subscription_1.default;
const ModalNames = {
    USER_CANCEL_SUBSCRIPTION: 'USER_CANCEL_SUBSCRIPTION',
    ORIGINAL_CANCEL_SUBSCRIPTION: 'ORIGINAL_CANCEL_SUBSCRIPTION',
    SUBSCRIPTION_SUCCESS: 'SUBSCRIPTION_SUCCESS',
    CHOOSE_WALLET: 'CHOOSE_WALLET',
    PAYMENT_PORTAL_SESSION_ERROR: 'PAYMENT_PORTAL_SESSION_ERROR',
    WALLET_CONNECTION_ERROR: 'WALLET_CONNECTION_ERROR',
};
exports.ModalNames = ModalNames;
